{
  "embed_url_form": {
    "validation": {
      "url_required": "Url is required",
      "name_required": "Name is required"
    },
    "modal": {
      "new_embed_url": "New Embed Url"
    },
    "fields": {
      "title": "Title",
      "url": "Url"
    }
  },
  "report_tabs": {
    "iframe_title": "Report {{name}}"
  }
}
